/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Doc&Board admin API
 * Doc&Board server admin API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '../custom-instance';
export type CompletionsBodyOptionsCommand = typeof CompletionsBodyOptionsCommand[keyof typeof CompletionsBodyOptionsCommand];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompletionsBodyOptionsCommand = {
  doctranslate: 'doc.translate',
  docmakeLonger: 'doc.makeLonger',
  docmakeShorter: 'doc.makeShorter',
  docfixSpelling: 'doc.fixSpelling',
  docfixGrammar: 'doc.fixGrammar',
  docfixGrammarAndSpelling: 'doc.fixGrammarAndSpelling',
  docchangeTone: 'doc.changeTone',
  docsummary: 'doc.summary',
  docsummaryAsTitle: 'doc.summaryAsTitle',
  docexplain: 'doc.explain',
  docarticleAbout: 'doc.articleAbout',
  docoutlineAbout: 'doc.outlineAbout',
  docimprove: 'doc.improve',
  docheader: 'doc.header',
  doccontinue: 'doc.continue',
} as const;

export type CompletionsBodyOptionsModel = typeof CompletionsBodyOptionsModel[keyof typeof CompletionsBodyOptionsModel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompletionsBodyOptionsModel = {
  puzzle: 'puzzle',
  ollama: 'ollama',
} as const;

export type CompletionsBodyOptions = {
  command?: CompletionsBodyOptionsCommand;
  args?: unknown;
  model?: CompletionsBodyOptionsModel;
};

export interface CompletionsBody {
  messages: unknown[];
  options: CompletionsBodyOptions;
}

export type TokenDataResponseOutputError = {
  status: number;
  message: string;
};

export type TokenDataResponseOutputData = {
  token: string;
  powersync_url: string;
};

export interface TokenDataResponseOutput {
  success: boolean;
  error?: TokenDataResponseOutputError;
  data?: TokenDataResponseOutputData;
}

export type SyncDataBodyBatchItemTable = typeof SyncDataBodyBatchItemTable[keyof typeof SyncDataBodyBatchItemTable];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SyncDataBodyBatchItemTable = {
  timers: 'timers',
} as const;

export type SyncDataBodyBatchItemOp = typeof SyncDataBodyBatchItemOp[keyof typeof SyncDataBodyBatchItemOp];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SyncDataBodyBatchItemOp = {
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
} as const;

export type SyncDataBodyBatchItem = {
  table: SyncDataBodyBatchItemTable;
  op: SyncDataBodyBatchItemOp;
  id: string;
  data: unknown;
};

export interface SyncDataBody {
  batch: SyncDataBodyBatchItem[];
}

export type SuccessResponseOutputError = {
  status: number;
  message: string;
};

export type SuccessResponseOutputData = {
  success: boolean;
};

export interface SuccessResponseOutput {
  success: boolean;
  error?: SuccessResponseOutputError;
  data?: SuccessResponseOutputData;
}

export interface UpdateUserAttributesBody {
  marketing_consents?: string;
  phone_number?: string;
}

export type UpdateUserAttributesResponseOutputError = {
  status: number;
  message: string;
};

export type UpdateUserAttributesResponseOutputDataAttributesItemName = typeof UpdateUserAttributesResponseOutputDataAttributesItemName[keyof typeof UpdateUserAttributesResponseOutputDataAttributesItemName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUserAttributesResponseOutputDataAttributesItemName = {
  marketing_consents: 'marketing_consents',
  phone_number: 'phone_number',
} as const;

export type UpdateUserAttributesResponseOutputDataAttributesItem = {
  userId: string;
  name: UpdateUserAttributesResponseOutputDataAttributesItemName;
  value: unknown;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
};

export type UpdateUserAttributesResponseOutputData = {
  attributes: UpdateUserAttributesResponseOutputDataAttributesItem[];
};

export interface UpdateUserAttributesResponseOutput {
  success: boolean;
  error?: UpdateUserAttributesResponseOutputError;
  data?: UpdateUserAttributesResponseOutputData;
}

export type UserAttributeName = typeof UserAttributeName[keyof typeof UserAttributeName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserAttributeName = {
  marketing_consents: 'marketing_consents',
  phone_number: 'phone_number',
} as const;

export type GetUserAttributeMetaResponseOutputError = {
  status: number;
  message: string;
};

export type GetUserAttributeMetaResponseOutputDataName = typeof GetUserAttributeMetaResponseOutputDataName[keyof typeof GetUserAttributeMetaResponseOutputDataName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserAttributeMetaResponseOutputDataName = {
  marketing_consents: 'marketing_consents',
  phone_number: 'phone_number',
} as const;

/**
 * @nullable
 */
export type GetUserAttributeMetaResponseOutputData = {
  userId: string;
  name: GetUserAttributeMetaResponseOutputDataName;
  value: unknown;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
} | null;

export interface GetUserAttributeMetaResponseOutput {
  success: boolean;
  error?: GetUserAttributeMetaResponseOutputError;
  /** @nullable */
  data?: GetUserAttributeMetaResponseOutputData;
}

export type GetUserAttributesMapResponseOutputError = {
  status: number;
  message: string;
};

export type GetUserAttributesMapResponseOutputDataAttributes = {
  marketing_consents?: boolean;
  phone_number?: string;
};

export type GetUserAttributesMapResponseOutputData = {
  attributes: GetUserAttributesMapResponseOutputDataAttributes;
};

export interface GetUserAttributesMapResponseOutput {
  success: boolean;
  error?: GetUserAttributesMapResponseOutputError;
  data?: GetUserAttributesMapResponseOutputData;
}

export type UserResponseOutputError = {
  status: number;
  message: string;
};

export type UserResponseOutputDataAvatarUrl = string | null;

export type UserResponseOutputDataHasPassword = boolean | null;

export type UserResponseOutputData = {
  id: string;
  name: string;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  avatarUrl: UserResponseOutputDataAvatarUrl;
  emailVerified: boolean;
  hasPassword: UserResponseOutputDataHasPassword;
};

export interface UserResponseOutput {
  success: boolean;
  error?: UserResponseOutputError;
  data?: UserResponseOutputData;
}

export interface GetUserByEmailBody {
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
}

export interface CreateUserBody {
  name?: string;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
}

export interface UpdateUserBody {
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email?: string;
  name?: string;
}

export type MarketingConsentsResponseOutputError = {
  status: number;
  message: string;
};

export type MarketingConsentsResponseOutputData = {
  userId: string;
  subscribed: boolean;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
};

export interface MarketingConsentsResponseOutput {
  success: boolean;
  error?: MarketingConsentsResponseOutputError;
  data?: MarketingConsentsResponseOutputData;
}

export interface PostSignInBody {
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  password?: string;
  callbackUrl?: string;
}

export type AccessTokenResponseOutputError = {
  status: number;
  message: string;
};

export type AccessTokenResponseOutputData = {
  id: string;
  name: string;
  token?: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  expiresAt: string;
};

export interface AccessTokenResponseOutput {
  success: boolean;
  error?: AccessTokenResponseOutputError;
  data?: AccessTokenResponseOutputData;
}

export type AccessTokenArrayResponseOutputError = {
  status: number;
  message: string;
};

export type AccessTokenArrayResponseOutputDataItemsItem = {
  id: string;
  name: string;
  token?: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  expiresAt: string;
};

export type AccessTokenArrayResponseOutputDataPagination = {
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 50
   */
  size: number;
  total_pages: number;
  total_items: number;
};

export type AccessTokenArrayResponseOutputData = {
  items: AccessTokenArrayResponseOutputDataItemsItem[];
  pagination?: AccessTokenArrayResponseOutputDataPagination;
};

export interface AccessTokenArrayResponseOutput {
  success: boolean;
  error?: AccessTokenArrayResponseOutputError;
  data?: AccessTokenArrayResponseOutputData;
}

export type CountResponseOutputError = {
  status: number;
  message: string;
};

export type CountResponseOutputData = {
  count: number;
};

export interface CountResponseOutput {
  success: boolean;
  error?: CountResponseOutputError;
  data?: CountResponseOutputData;
}

export type UserQuotaResponseOutputError = {
  status: number;
  message: string;
};

export type UserQuotaResponseOutputDataName = typeof UserQuotaResponseOutputDataName[keyof typeof UserQuotaResponseOutputDataName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserQuotaResponseOutputDataName = {
  administrator: 'administrator',
  early_access: 'early_access',
  ai_early_access: 'ai_early_access',
  unlimited_copilot: 'unlimited_copilot',
  wiki_admin: 'wiki_admin',
  unlimited_workspace: 'unlimited_workspace',
  team_plan_v1: 'team_plan_v1',
  free_plan_v1: 'free_plan_v1',
  basic_plan_v1: 'basic_plan_v1',
  pro_plan_v1: 'pro_plan_v1',
  unlimited: 'unlimited',
  restricted_plan_v1: 'restricted_plan_v1',
  copilot: 'copilot',
  lifetime_pro_plan_v1: 'lifetime_pro_plan_v1',
} as const;

export type UserQuotaResponseOutputDataConvertersItem = typeof UserQuotaResponseOutputDataConvertersItem[keyof typeof UserQuotaResponseOutputDataConvertersItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserQuotaResponseOutputDataConvertersItem = {
  dnb_to_docx: 'dnb_to_docx',
  dnb_to_html: 'dnb_to_html',
  dnb_to_pdf: 'dnb_to_pdf',
  dnb_to_md: 'dnb_to_md',
  miro_to_dnb: 'miro_to_dnb',
  docx_to_md: 'docx_to_md',
  docx_to_html: 'docx_to_html',
} as const;

export type UserQuotaResponseOutputDataDisplayFormat = {
  name: string;
  blobLimit: string;
  storageQuota: string;
  historyPeriod: string;
  memberLimit: string;
  copilotActionLimit: string;
};

export type UserQuotaResponseOutputData = {
  name: UserQuotaResponseOutputDataName;
  blobLimit: number;
  storageQuota: number;
  historyPeriod: number;
  /** @nullable */
  memberLimit?: number | null;
  converters: UserQuotaResponseOutputDataConvertersItem[];
  workspaceLimit: number;
  /** @nullable */
  docLimit?: number | null;
  guestInvite: boolean;
  timer: boolean;
  /** @nullable */
  copilotActionLimit?: number | null;
  displayFormat: UserQuotaResponseOutputDataDisplayFormat;
};

export interface UserQuotaResponseOutput {
  success: boolean;
  error?: UserQuotaResponseOutputError;
  data?: UserQuotaResponseOutputData;
}

export interface PublishGuestDocBody {
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  sendInviteMail?: boolean;
}

export interface RevokeGuestDocBody {
  userId: string;
}

export type GuestUserArrayResponseOutputError = {
  status: number;
  message: string;
};

export type GuestUserArrayResponseOutputDataItemsItem = {
  id: string;
  name: string;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  registered: boolean;
  /** @nullable */
  avatarUrl: string | null;
};

export type GuestUserArrayResponseOutputDataPagination = {
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 50
   */
  size: number;
  total_pages: number;
  total_items: number;
};

export type GuestUserArrayResponseOutputData = {
  items: GuestUserArrayResponseOutputDataItemsItem[];
  pagination?: GuestUserArrayResponseOutputDataPagination;
};

export interface GuestUserArrayResponseOutput {
  success: boolean;
  error?: GuestUserArrayResponseOutputError;
  data?: GuestUserArrayResponseOutputData;
}

export type DocMetaResponseOutputError = {
  status: number;
  message: string;
};

export type DocMetaResponseOutputDataTagsItem = {
  value: string;
  createTimestamp?: number;
  updateTimestamp?: number;
};

export type DocMetaResponseOutputData = {
  title: string;
  createTimestamp: number;
  updateTimestamp?: number;
  tags?: DocMetaResponseOutputDataTagsItem[];
};

export interface DocMetaResponseOutput {
  success: boolean;
  error?: DocMetaResponseOutputError;
  data?: DocMetaResponseOutputData;
}

export type AuthStateResponseOutputError = {
  status: number;
  message: string;
};

export type AuthStateResponseOutputData = {
  isAuthorized: boolean;
};

export interface AuthStateResponseOutput {
  success: boolean;
  error?: AuthStateResponseOutputError;
  data?: AuthStateResponseOutputData;
}

export type MiroBoardArrayResponseOutputError = {
  status: number;
  message: string;
};

export type MiroBoardArrayResponseOutputDataItemsItemPicture = {
  imageURL?: string;
};

export type MiroBoardArrayResponseOutputDataItemsItem = {
  id: number;
  boardId: string;
  name: string;
  owner?: unknown;
  picture: MiroBoardArrayResponseOutputDataItemsItemPicture;
};

export type MiroBoardArrayResponseOutputDataPagination = {
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 50
   */
  size: number;
  total_pages: number;
  total_items: number;
};

export type MiroBoardArrayResponseOutputData = {
  items: MiroBoardArrayResponseOutputDataItemsItem[];
  pagination?: MiroBoardArrayResponseOutputDataPagination;
};

export interface MiroBoardArrayResponseOutput {
  success: boolean;
  error?: MiroBoardArrayResponseOutputError;
  data?: MiroBoardArrayResponseOutputData;
}

export type GetWikiStatusResponseOutputError = {
  status: number;
  message: string;
};

export type GetWikiStatusResponseOutputData = {
  enable: boolean;
};

export interface GetWikiStatusResponseOutput {
  success: boolean;
  error?: GetWikiStatusResponseOutputError;
  data?: GetWikiStatusResponseOutputData;
}

export type GetWikiDocByWorkspaceArrayResponseOutputError = {
  status: number;
  message: string;
};

export type GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemCreatedBy = {
  name: string;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  avatarUrl: string;
};

export type GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemUpdatedBy = {
  name: string;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  avatarUrl: string;
};

export type GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemStatus = typeof GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemStatus[keyof typeof GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemStatus = {
  Unpublished: 'Unpublished',
  Published: 'Published',
} as const;

export type GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemSyncStatus = typeof GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemSyncStatus[keyof typeof GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemSyncStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemSyncStatus = {
  Publishing: 'Publishing',
  Deleting: 'Deleting',
  Failed: 'Failed',
  Completed: 'Completed',
} as const;

export type GetWikiDocByWorkspaceArrayResponseOutputDataItemsItem = {
  docId: string;
  workspaceId: string;
  createdBy: GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemCreatedBy;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  updatedBy: GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemUpdatedBy;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
  status: GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemStatus;
  syncStatus: GetWikiDocByWorkspaceArrayResponseOutputDataItemsItemSyncStatus;
};

export type GetWikiDocByWorkspaceArrayResponseOutputDataPagination = {
  /** @minimum 1 */
  page: number;
  /**
   * @minimum 1
   * @maximum 50
   */
  size: number;
  total_pages: number;
  total_items: number;
};

export type GetWikiDocByWorkspaceArrayResponseOutputData = {
  items: GetWikiDocByWorkspaceArrayResponseOutputDataItemsItem[];
  pagination?: GetWikiDocByWorkspaceArrayResponseOutputDataPagination;
};

export interface GetWikiDocByWorkspaceArrayResponseOutput {
  success: boolean;
  error?: GetWikiDocByWorkspaceArrayResponseOutputError;
  data?: GetWikiDocByWorkspaceArrayResponseOutputData;
}

export type PostDocsStatusBodyAction = typeof PostDocsStatusBodyAction[keyof typeof PostDocsStatusBodyAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostDocsStatusBodyAction = {
  add: 'add',
  publish: 'publish',
  unpublish: 'unpublish',
  delete: 'delete',
} as const;

export interface PostDocsStatusBody {
  workspaceId: string;
  docIds: string[];
  action: PostDocsStatusBodyAction;
}

export type GetWikiDocByWorkspaceResponseOutputError = {
  status: number;
  message: string;
};

export type GetWikiDocByWorkspaceResponseOutputDataCreatedBy = {
  name: string;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  avatarUrl: string;
};

export type GetWikiDocByWorkspaceResponseOutputDataUpdatedBy = {
  name: string;
  /** @pattern ^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$ */
  email: string;
  avatarUrl: string;
};

export type GetWikiDocByWorkspaceResponseOutputDataStatus = typeof GetWikiDocByWorkspaceResponseOutputDataStatus[keyof typeof GetWikiDocByWorkspaceResponseOutputDataStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWikiDocByWorkspaceResponseOutputDataStatus = {
  Unpublished: 'Unpublished',
  Published: 'Published',
} as const;

export type GetWikiDocByWorkspaceResponseOutputDataSyncStatus = typeof GetWikiDocByWorkspaceResponseOutputDataSyncStatus[keyof typeof GetWikiDocByWorkspaceResponseOutputDataSyncStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWikiDocByWorkspaceResponseOutputDataSyncStatus = {
  Publishing: 'Publishing',
  Deleting: 'Deleting',
  Failed: 'Failed',
  Completed: 'Completed',
} as const;

export type GetWikiDocByWorkspaceResponseOutputData = {
  docId: string;
  workspaceId: string;
  createdBy: GetWikiDocByWorkspaceResponseOutputDataCreatedBy;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  updatedBy: GetWikiDocByWorkspaceResponseOutputDataUpdatedBy;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
  status: GetWikiDocByWorkspaceResponseOutputDataStatus;
  syncStatus: GetWikiDocByWorkspaceResponseOutputDataSyncStatus;
};

export interface GetWikiDocByWorkspaceResponseOutput {
  success: boolean;
  error?: GetWikiDocByWorkspaceResponseOutputError;
  data?: GetWikiDocByWorkspaceResponseOutputData;
}

export type SurveyName = typeof SurveyName[keyof typeof SurveyName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyName = {
  start_v1: 'start_v1',
} as const;

export type PostResponseBodyResponses = { [key: string]: unknown };

export interface PostResponseBody {
  name: SurveyName;
  responses: PostResponseBodyResponses;
}

export type SurveySchemaResponseOutputError = {
  status: number;
  message: string;
};

export type SurveySchemaResponseOutputDataSurveyName = typeof SurveySchemaResponseOutputDataSurveyName[keyof typeof SurveySchemaResponseOutputDataSurveyName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveySchemaResponseOutputDataSurveyName = {
  start_v1: 'start_v1',
} as const;

export type SurveySchemaResponseOutputDataResultObj = {[key: string]: string};

export type SurveySchemaResponseOutputData = {
  surveyName: SurveySchemaResponseOutputDataSurveyName;
  userId: string;
  completed: boolean;
  resultObj: SurveySchemaResponseOutputDataResultObj;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  /**
   * @nullable
   * @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$
   */
  updatedAt: string | null;
};

export interface SurveySchemaResponseOutput {
  success: boolean;
  error?: SurveySchemaResponseOutputError;
  data?: SurveySchemaResponseOutputData;
}

export type FbSurveySchemaResponseOutputError = {
  status: number;
  message: string;
};

export type FbSurveySchemaResponseOutputDataSchema = {[key: string]: string};

export type FbSurveySchemaResponseOutputData = {
  schema: FbSurveySchemaResponseOutputDataSchema;
};

export interface FbSurveySchemaResponseOutput {
  success: boolean;
  error?: FbSurveySchemaResponseOutputError;
  data?: FbSurveySchemaResponseOutputData;
}

export type UserAttributesControllerGetUserAttributesListParams = {
attributes: UserAttributeName[];
};

export type UserAttributesControllerGetUserAttributeParams = {
attribute: UserAttributeName;
};

export type MarketingControllerUpdateMarketingConsentsParams = {
subscribed: string;
};

export type AccessTokenControllerPostCreateParams = {
name: string;
};

export type AccessTokenControllerGetListParams = {
page?: number;
size?: number;
};

export type PublishDocControllerPostGuestsParams = {
page?: number;
size?: number;
};

export type DocManagerControllerPostCreateBody = {
  /** Заголовок документа */
  title?: string;
  /** Поддерживаются файлы в формате *.md, *.zip и размером не превышающим 10mb */
  file: Blob;
};

/**
 * Режим добавления (default: back)
 */
export type DocManagerControllerPostAddBodyMode = typeof DocManagerControllerPostAddBodyMode[keyof typeof DocManagerControllerPostAddBodyMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocManagerControllerPostAddBodyMode = {
  back: 'back',
  front: 'front',
  update: 'update',
} as const;

export type DocManagerControllerPostAddBody = {
  /** Режим добавления (default: back) */
  mode?: DocManagerControllerPostAddBodyMode;
  /** Поддерживаются файлы в формате *.md, *.zip и размером не превышающим 10mb */
  file: Blob;
};

export type DocManagerControllerGetFileContentParams = {
format: DocManagerControllerGetFileContentFormat;
};

export type DocManagerControllerGetFileContentFormat = typeof DocManagerControllerGetFileContentFormat[keyof typeof DocManagerControllerGetFileContentFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocManagerControllerGetFileContentFormat = {
  markdown: 'markdown',
  html: 'html',
} as const;

export type DocConverterControllerPostConvertBodyType = typeof DocConverterControllerPostConvertBodyType[keyof typeof DocConverterControllerPostConvertBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocConverterControllerPostConvertBodyType = {
  dnb_to_docx: 'dnb_to_docx',
  dnb_to_html: 'dnb_to_html',
  dnb_to_pdf: 'dnb_to_pdf',
  dnb_to_md: 'dnb_to_md',
} as const;

export type DocConverterControllerPostConvertBody = {
  type: DocConverterControllerPostConvertBodyType;
  workspaceId: string;
  docId: string;
};

export type FileConverterControllerPostConvertBodyType = typeof FileConverterControllerPostConvertBodyType[keyof typeof FileConverterControllerPostConvertBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileConverterControllerPostConvertBodyType = {
  docx_to_md: 'docx_to_md',
  docx_to_html: 'docx_to_html',
} as const;

export type FileConverterControllerPostConvertBody = {
  type: FileConverterControllerPostConvertBodyType;
  /** При наличии ресурсов для *.md файла ожидается *.zip архив */
  file: Blob;
};

export type FolderConverterControllerPostConvertBody = {
  sourcePath: string;
  targetPath: string;
};

export type WikiControllerGetWikiStatusParams = {
workspaceId: string;
};

export type WikiControllerPostWorkspaceAsWikiParams = {
workspaceId: string;
enable: string;
};

export type WikiControllerGetWikiDocsByWorkspaceParams = {
workspaceId?: string;
syncStatus?: WikiControllerGetWikiDocsByWorkspaceSyncStatus;
};

export type WikiControllerGetWikiDocsByWorkspaceSyncStatus = typeof WikiControllerGetWikiDocsByWorkspaceSyncStatus[keyof typeof WikiControllerGetWikiDocsByWorkspaceSyncStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WikiControllerGetWikiDocsByWorkspaceSyncStatus = {
  Publishing: 'Publishing',
  Deleting: 'Deleting',
  Failed: 'Failed',
  Completed: 'Completed',
} as const;

export type WikiControllerGetWikiDocByWorkspaceParams = {
workspaceId: string;
};

export type WikiDocControllerGetFileContentParams = {
format: WikiDocControllerGetFileContentFormat;
workspaceId: string;
};

export type WikiDocControllerGetFileContentFormat = typeof WikiDocControllerGetFileContentFormat[keyof typeof WikiDocControllerGetFileContentFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WikiDocControllerGetFileContentFormat = {
  markdown: 'markdown',
  html: 'html',
} as const;

export type WikiDocControllerGetDocMetaParams = {
workspaceId: string;
};

export type SurveyControllerGetSurveyParams = {
name: SurveyName;
};

export type SurveyControllerGetFbSurveyParams = {
name: SurveyName;
};

export type UnisenderAdminControllerGetContactParams = {
email: string;
};

export type UnisenderAdminControllerPostSubscribeParams = {
email: string;
userId: string;
};

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




/**
 * @summary Сгенерировать потоковый ответ на запрос
 */
export const aiControllerPostCompletions = (
    completionsBody: CompletionsBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/ai/completions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completionsBody, signal
    },
      );
    }
  


export const getAiControllerPostCompletionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiControllerPostCompletions>>, TError,{data: CompletionsBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof aiControllerPostCompletions>>, TError,{data: CompletionsBody}, TContext> => {
    
const mutationKey = ['aiControllerPostCompletions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiControllerPostCompletions>>, {data: CompletionsBody}> = (props) => {
          const {data} = props ?? {};

          return  aiControllerPostCompletions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AiControllerPostCompletionsMutationResult = NonNullable<Awaited<ReturnType<typeof aiControllerPostCompletions>>>
    export type AiControllerPostCompletionsMutationBody = CompletionsBody
    export type AiControllerPostCompletionsMutationError = unknown

    /**
 * @summary Сгенерировать потоковый ответ на запрос
 */
export const useAiControllerPostCompletions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiControllerPostCompletions>>, TError,{data: CompletionsBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof aiControllerPostCompletions>>,
        TError,
        {data: CompletionsBody},
        TContext
      > => {

      const mutationOptions = getAiControllerPostCompletionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Создать JWT-токен для пользователя
 */
export const authControllerGetToken = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<TokenDataResponseOutput>(
      {url: `/api/v2/sync/auth/token`, method: 'GET', signal
    },
      );
    }
  

export const getAuthControllerGetTokenQueryKey = () => {
    return [`/api/v2/sync/auth/token`] as const;
    }

    
export const getAuthControllerGetTokenQueryOptions = <TData = Awaited<ReturnType<typeof authControllerGetToken>>, TError = TokenDataResponseOutput>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerGetToken>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerGetTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetToken>>> = ({ signal }) => authControllerGetToken(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerGetToken>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthControllerGetTokenQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerGetToken>>>
export type AuthControllerGetTokenQueryError = TokenDataResponseOutput


/**
 * @summary Создать JWT-токен для пользователя
 */

export function useAuthControllerGetToken<TData = Awaited<ReturnType<typeof authControllerGetToken>>, TError = TokenDataResponseOutput>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerGetToken>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuthControllerGetTokenQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Создать JWT-токен с временем жизни 1day (dev)
 */
export const authControllerGetDevToken = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/sync/auth/dev-token`, method: 'GET', signal
    },
      );
    }
  

export const getAuthControllerGetDevTokenQueryKey = () => {
    return [`/api/v2/sync/auth/dev-token`] as const;
    }

    
export const getAuthControllerGetDevTokenQueryOptions = <TData = Awaited<ReturnType<typeof authControllerGetDevToken>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerGetDevToken>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerGetDevTokenQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetDevToken>>> = ({ signal }) => authControllerGetDevToken(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerGetDevToken>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthControllerGetDevTokenQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerGetDevToken>>>
export type AuthControllerGetDevTokenQueryError = unknown


/**
 * @summary Создать JWT-токен с временем жизни 1day (dev)
 */

export function useAuthControllerGetDevToken<TData = Awaited<ReturnType<typeof authControllerGetDevToken>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerGetDevToken>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuthControllerGetDevTokenQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить публичные ключи доступа
 */
export const authControllerGetKeys = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/sync/auth/keys`, method: 'GET', signal
    },
      );
    }
  

export const getAuthControllerGetKeysQueryKey = () => {
    return [`/api/v2/sync/auth/keys`] as const;
    }

    
export const getAuthControllerGetKeysQueryOptions = <TData = Awaited<ReturnType<typeof authControllerGetKeys>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerGetKeys>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerGetKeysQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetKeys>>> = ({ signal }) => authControllerGetKeys(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerGetKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthControllerGetKeysQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerGetKeys>>>
export type AuthControllerGetKeysQueryError = unknown


/**
 * @summary Получить публичные ключи доступа
 */

export function useAuthControllerGetKeys<TData = Awaited<ReturnType<typeof authControllerGetKeys>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerGetKeys>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuthControllerGetKeysQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Post data
 */
export const dataControllerPost = (
    syncDataBody: SyncDataBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/sync/data`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncDataBody, signal
    },
      );
    }
  


export const getDataControllerPostMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dataControllerPost>>, TError,{data: SyncDataBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dataControllerPost>>, TError,{data: SyncDataBody}, TContext> => {
    
const mutationKey = ['dataControllerPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dataControllerPost>>, {data: SyncDataBody}> = (props) => {
          const {data} = props ?? {};

          return  dataControllerPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DataControllerPostMutationResult = NonNullable<Awaited<ReturnType<typeof dataControllerPost>>>
    export type DataControllerPostMutationBody = SyncDataBody
    export type DataControllerPostMutationError = SuccessResponseOutput

    /**
 * @summary Post data
 */
export const useDataControllerPost = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dataControllerPost>>, TError,{data: SyncDataBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof dataControllerPost>>,
        TError,
        {data: SyncDataBody},
        TContext
      > => {

      const mutationOptions = getDataControllerPostMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Обновить пользовательские атрибуты
 */
export const userAttributesControllerUpdateUserAttributes = (
    updateUserAttributesBody: UpdateUserAttributesBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UpdateUserAttributesResponseOutput>(
      {url: `/api/v2/user/attributes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUserAttributesBody, signal
    },
      );
    }
  


export const getUserAttributesControllerUpdateUserAttributesMutationOptions = <TError = UpdateUserAttributesResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAttributesControllerUpdateUserAttributes>>, TError,{data: UpdateUserAttributesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof userAttributesControllerUpdateUserAttributes>>, TError,{data: UpdateUserAttributesBody}, TContext> => {
    
const mutationKey = ['userAttributesControllerUpdateUserAttributes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userAttributesControllerUpdateUserAttributes>>, {data: UpdateUserAttributesBody}> = (props) => {
          const {data} = props ?? {};

          return  userAttributesControllerUpdateUserAttributes(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserAttributesControllerUpdateUserAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof userAttributesControllerUpdateUserAttributes>>>
    export type UserAttributesControllerUpdateUserAttributesMutationBody = UpdateUserAttributesBody
    export type UserAttributesControllerUpdateUserAttributesMutationError = UpdateUserAttributesResponseOutput

    /**
 * @summary Обновить пользовательские атрибуты
 */
export const useUserAttributesControllerUpdateUserAttributes = <TError = UpdateUserAttributesResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userAttributesControllerUpdateUserAttributes>>, TError,{data: UpdateUserAttributesBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof userAttributesControllerUpdateUserAttributes>>,
        TError,
        {data: UpdateUserAttributesBody},
        TContext
      > => {

      const mutationOptions = getUserAttributesControllerUpdateUserAttributesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить пользовательские атрибуты
 */
export const userAttributesControllerGetUserAttributesList = (
    params: UserAttributesControllerGetUserAttributesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUserAttributesMapResponseOutput>(
      {url: `/api/v2/user/attributes`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getUserAttributesControllerGetUserAttributesListQueryKey = (params: UserAttributesControllerGetUserAttributesListParams,) => {
    return [`/api/v2/user/attributes`, ...(params ? [params]: [])] as const;
    }

    
export const getUserAttributesControllerGetUserAttributesListQueryOptions = <TData = Awaited<ReturnType<typeof userAttributesControllerGetUserAttributesList>>, TError = GetUserAttributesMapResponseOutput>(params: UserAttributesControllerGetUserAttributesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userAttributesControllerGetUserAttributesList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserAttributesControllerGetUserAttributesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userAttributesControllerGetUserAttributesList>>> = ({ signal }) => userAttributesControllerGetUserAttributesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userAttributesControllerGetUserAttributesList>>, TError, TData> & { queryKey: QueryKey }
}

export type UserAttributesControllerGetUserAttributesListQueryResult = NonNullable<Awaited<ReturnType<typeof userAttributesControllerGetUserAttributesList>>>
export type UserAttributesControllerGetUserAttributesListQueryError = GetUserAttributesMapResponseOutput


/**
 * @summary Получить пользовательские атрибуты
 */

export function useUserAttributesControllerGetUserAttributesList<TData = Awaited<ReturnType<typeof userAttributesControllerGetUserAttributesList>>, TError = GetUserAttributesMapResponseOutput>(
 params: UserAttributesControllerGetUserAttributesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userAttributesControllerGetUserAttributesList>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUserAttributesControllerGetUserAttributesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить описание пользовательского атрибута
 */
export const userAttributesControllerGetUserAttribute = (
    params: UserAttributesControllerGetUserAttributeParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUserAttributeMetaResponseOutput>(
      {url: `/api/v2/user/attributes/meta`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getUserAttributesControllerGetUserAttributeQueryKey = (params: UserAttributesControllerGetUserAttributeParams,) => {
    return [`/api/v2/user/attributes/meta`, ...(params ? [params]: [])] as const;
    }

    
export const getUserAttributesControllerGetUserAttributeQueryOptions = <TData = Awaited<ReturnType<typeof userAttributesControllerGetUserAttribute>>, TError = GetUserAttributeMetaResponseOutput>(params: UserAttributesControllerGetUserAttributeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userAttributesControllerGetUserAttribute>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserAttributesControllerGetUserAttributeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userAttributesControllerGetUserAttribute>>> = ({ signal }) => userAttributesControllerGetUserAttribute(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userAttributesControllerGetUserAttribute>>, TError, TData> & { queryKey: QueryKey }
}

export type UserAttributesControllerGetUserAttributeQueryResult = NonNullable<Awaited<ReturnType<typeof userAttributesControllerGetUserAttribute>>>
export type UserAttributesControllerGetUserAttributeQueryError = GetUserAttributeMetaResponseOutput


/**
 * @summary Получить описание пользовательского атрибута
 */

export function useUserAttributesControllerGetUserAttribute<TData = Awaited<ReturnType<typeof userAttributesControllerGetUserAttribute>>, TError = GetUserAttributeMetaResponseOutput>(
 params: UserAttributesControllerGetUserAttributeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userAttributesControllerGetUserAttribute>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUserAttributesControllerGetUserAttributeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить пользователя (Admin)
 */
export const adminUserControllerGetUserById = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserResponseOutput>(
      {url: `/api/v2/users/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminUserControllerGetUserByIdQueryKey = (id: string,) => {
    return [`/api/v2/users/${id}`] as const;
    }

    
export const getAdminUserControllerGetUserByIdQueryOptions = <TData = Awaited<ReturnType<typeof adminUserControllerGetUserById>>, TError = UserResponseOutput>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminUserControllerGetUserById>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminUserControllerGetUserByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminUserControllerGetUserById>>> = ({ signal }) => adminUserControllerGetUserById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminUserControllerGetUserById>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminUserControllerGetUserByIdQueryResult = NonNullable<Awaited<ReturnType<typeof adminUserControllerGetUserById>>>
export type AdminUserControllerGetUserByIdQueryError = UserResponseOutput


/**
 * @summary Получить пользователя (Admin)
 */

export function useAdminUserControllerGetUserById<TData = Awaited<ReturnType<typeof adminUserControllerGetUserById>>, TError = UserResponseOutput>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminUserControllerGetUserById>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminUserControllerGetUserByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Обновить профиль пользователя (Admin)
 */
export const adminUserControllerUpdateUser = (
    id: string,
    updateUserBody: UpdateUserBody,
 ) => {
      
      
      return customInstance<UserResponseOutput>(
      {url: `/api/v2/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserBody
    },
      );
    }
  


export const getAdminUserControllerUpdateUserMutationOptions = <TError = UserResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUserControllerUpdateUser>>, TError,{id: string;data: UpdateUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminUserControllerUpdateUser>>, TError,{id: string;data: UpdateUserBody}, TContext> => {
    
const mutationKey = ['adminUserControllerUpdateUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUserControllerUpdateUser>>, {id: string;data: UpdateUserBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUserControllerUpdateUser(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUserControllerUpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof adminUserControllerUpdateUser>>>
    export type AdminUserControllerUpdateUserMutationBody = UpdateUserBody
    export type AdminUserControllerUpdateUserMutationError = UserResponseOutput

    /**
 * @summary Обновить профиль пользователя (Admin)
 */
export const useAdminUserControllerUpdateUser = <TError = UserResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUserControllerUpdateUser>>, TError,{id: string;data: UpdateUserBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminUserControllerUpdateUser>>,
        TError,
        {id: string;data: UpdateUserBody},
        TContext
      > => {

      const mutationOptions = getAdminUserControllerUpdateUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить пользователя по email (Admin)
 */
export const adminUserControllerGetUserByEmail = (
    getUserByEmailBody: GetUserByEmailBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserResponseOutput>(
      {url: `/api/v2/users/getByEmail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getUserByEmailBody, signal
    },
      );
    }
  


export const getAdminUserControllerGetUserByEmailMutationOptions = <TError = UserResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUserControllerGetUserByEmail>>, TError,{data: GetUserByEmailBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminUserControllerGetUserByEmail>>, TError,{data: GetUserByEmailBody}, TContext> => {
    
const mutationKey = ['adminUserControllerGetUserByEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUserControllerGetUserByEmail>>, {data: GetUserByEmailBody}> = (props) => {
          const {data} = props ?? {};

          return  adminUserControllerGetUserByEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUserControllerGetUserByEmailMutationResult = NonNullable<Awaited<ReturnType<typeof adminUserControllerGetUserByEmail>>>
    export type AdminUserControllerGetUserByEmailMutationBody = GetUserByEmailBody
    export type AdminUserControllerGetUserByEmailMutationError = UserResponseOutput

    /**
 * @summary Получить пользователя по email (Admin)
 */
export const useAdminUserControllerGetUserByEmail = <TError = UserResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUserControllerGetUserByEmail>>, TError,{data: GetUserByEmailBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminUserControllerGetUserByEmail>>,
        TError,
        {data: GetUserByEmailBody},
        TContext
      > => {

      const mutationOptions = getAdminUserControllerGetUserByEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Создать нового пользователя (Admin)
 */
export const adminUserControllerCreateUser = (
    createUserBody: CreateUserBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserResponseOutput>(
      {url: `/api/v2/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserBody, signal
    },
      );
    }
  


export const getAdminUserControllerCreateUserMutationOptions = <TError = UserResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUserControllerCreateUser>>, TError,{data: CreateUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminUserControllerCreateUser>>, TError,{data: CreateUserBody}, TContext> => {
    
const mutationKey = ['adminUserControllerCreateUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUserControllerCreateUser>>, {data: CreateUserBody}> = (props) => {
          const {data} = props ?? {};

          return  adminUserControllerCreateUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUserControllerCreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof adminUserControllerCreateUser>>>
    export type AdminUserControllerCreateUserMutationBody = CreateUserBody
    export type AdminUserControllerCreateUserMutationError = UserResponseOutput

    /**
 * @summary Создать нового пользователя (Admin)
 */
export const useAdminUserControllerCreateUser = <TError = UserResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUserControllerCreateUser>>, TError,{data: CreateUserBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminUserControllerCreateUser>>,
        TError,
        {data: CreateUserBody},
        TContext
      > => {

      const mutationOptions = getAdminUserControllerCreateUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @deprecated
 * @summary Подписать/Отписаться на получение рекламной рассылки
 */
export const marketingControllerUpdateMarketingConsents = (
    params: MarketingControllerUpdateMarketingConsentsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MarketingConsentsResponseOutput>(
      {url: `/api/v2/user/attributes/marketing-consents`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getMarketingControllerUpdateMarketingConsentsMutationOptions = <TError = MarketingConsentsResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingControllerUpdateMarketingConsents>>, TError,{params: MarketingControllerUpdateMarketingConsentsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof marketingControllerUpdateMarketingConsents>>, TError,{params: MarketingControllerUpdateMarketingConsentsParams}, TContext> => {
    
const mutationKey = ['marketingControllerUpdateMarketingConsents'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof marketingControllerUpdateMarketingConsents>>, {params: MarketingControllerUpdateMarketingConsentsParams}> = (props) => {
          const {params} = props ?? {};

          return  marketingControllerUpdateMarketingConsents(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarketingControllerUpdateMarketingConsentsMutationResult = NonNullable<Awaited<ReturnType<typeof marketingControllerUpdateMarketingConsents>>>
    
    export type MarketingControllerUpdateMarketingConsentsMutationError = MarketingConsentsResponseOutput

    /**
 * @deprecated
 * @summary Подписать/Отписаться на получение рекламной рассылки
 */
export const useMarketingControllerUpdateMarketingConsents = <TError = MarketingConsentsResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingControllerUpdateMarketingConsents>>, TError,{params: MarketingControllerUpdateMarketingConsentsParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof marketingControllerUpdateMarketingConsents>>,
        TError,
        {params: MarketingControllerUpdateMarketingConsentsParams},
        TContext
      > => {

      const mutationOptions = getMarketingControllerUpdateMarketingConsentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @deprecated
 * @summary Получить подписку на получение рекламной рассылки
 */
export const marketingControllerGetMarketingConsents = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MarketingConsentsResponseOutput>(
      {url: `/api/v2/user/attributes/marketing-consents`, method: 'GET', signal
    },
      );
    }
  

export const getMarketingControllerGetMarketingConsentsQueryKey = () => {
    return [`/api/v2/user/attributes/marketing-consents`] as const;
    }

    
export const getMarketingControllerGetMarketingConsentsQueryOptions = <TData = Awaited<ReturnType<typeof marketingControllerGetMarketingConsents>>, TError = MarketingConsentsResponseOutput>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof marketingControllerGetMarketingConsents>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketingControllerGetMarketingConsentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketingControllerGetMarketingConsents>>> = ({ signal }) => marketingControllerGetMarketingConsents(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketingControllerGetMarketingConsents>>, TError, TData> & { queryKey: QueryKey }
}

export type MarketingControllerGetMarketingConsentsQueryResult = NonNullable<Awaited<ReturnType<typeof marketingControllerGetMarketingConsents>>>
export type MarketingControllerGetMarketingConsentsQueryError = MarketingConsentsResponseOutput


/**
 * @deprecated
 * @summary Получить подписку на получение рекламной рассылки
 */

export function useMarketingControllerGetMarketingConsents<TData = Awaited<ReturnType<typeof marketingControllerGetMarketingConsents>>, TError = MarketingConsentsResponseOutput>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof marketingControllerGetMarketingConsents>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMarketingControllerGetMarketingConsentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Авторизаваться
 */
export const authControllerSignIn = (
    postSignInBody: PostSignInBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/auth/sign-in`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSignInBody, signal
    },
      );
    }
  


export const getAuthControllerSignInMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSignIn>>, TError,{data: PostSignInBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerSignIn>>, TError,{data: PostSignInBody}, TContext> => {
    
const mutationKey = ['authControllerSignIn'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerSignIn>>, {data: PostSignInBody}> = (props) => {
          const {data} = props ?? {};

          return  authControllerSignIn(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerSignInMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerSignIn>>>
    export type AuthControllerSignInMutationBody = PostSignInBody
    export type AuthControllerSignInMutationError = unknown

    /**
 * @summary Авторизаваться
 */
export const useAuthControllerSignIn = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSignIn>>, TError,{data: PostSignInBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerSignIn>>,
        TError,
        {data: PostSignInBody},
        TContext
      > => {

      const mutationOptions = getAuthControllerSignInMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Создать персональный токен доступа
 */
export const accessTokenControllerPostCreate = (
    params: AccessTokenControllerPostCreateParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AccessTokenResponseOutput>(
      {url: `/api/v2/auth/access_tokens`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getAccessTokenControllerPostCreateMutationOptions = <TError = AccessTokenResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerPostCreate>>, TError,{params: AccessTokenControllerPostCreateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerPostCreate>>, TError,{params: AccessTokenControllerPostCreateParams}, TContext> => {
    
const mutationKey = ['accessTokenControllerPostCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accessTokenControllerPostCreate>>, {params: AccessTokenControllerPostCreateParams}> = (props) => {
          const {params} = props ?? {};

          return  accessTokenControllerPostCreate(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AccessTokenControllerPostCreateMutationResult = NonNullable<Awaited<ReturnType<typeof accessTokenControllerPostCreate>>>
    
    export type AccessTokenControllerPostCreateMutationError = AccessTokenResponseOutput

    /**
 * @summary Создать персональный токен доступа
 */
export const useAccessTokenControllerPostCreate = <TError = AccessTokenResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerPostCreate>>, TError,{params: AccessTokenControllerPostCreateParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof accessTokenControllerPostCreate>>,
        TError,
        {params: AccessTokenControllerPostCreateParams},
        TContext
      > => {

      const mutationOptions = getAccessTokenControllerPostCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить список персональных токенов доступа
 */
export const accessTokenControllerGetList = (
    params?: AccessTokenControllerGetListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AccessTokenArrayResponseOutput>(
      {url: `/api/v2/auth/access_tokens`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAccessTokenControllerGetListQueryKey = (params?: AccessTokenControllerGetListParams,) => {
    return [`/api/v2/auth/access_tokens`, ...(params ? [params]: [])] as const;
    }

    
export const getAccessTokenControllerGetListQueryOptions = <TData = Awaited<ReturnType<typeof accessTokenControllerGetList>>, TError = AccessTokenArrayResponseOutput>(params?: AccessTokenControllerGetListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof accessTokenControllerGetList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccessTokenControllerGetListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof accessTokenControllerGetList>>> = ({ signal }) => accessTokenControllerGetList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accessTokenControllerGetList>>, TError, TData> & { queryKey: QueryKey }
}

export type AccessTokenControllerGetListQueryResult = NonNullable<Awaited<ReturnType<typeof accessTokenControllerGetList>>>
export type AccessTokenControllerGetListQueryError = AccessTokenArrayResponseOutput


/**
 * @summary Получить список персональных токенов доступа
 */

export function useAccessTokenControllerGetList<TData = Awaited<ReturnType<typeof accessTokenControllerGetList>>, TError = AccessTokenArrayResponseOutput>(
 params?: AccessTokenControllerGetListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof accessTokenControllerGetList>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAccessTokenControllerGetListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Отозвать персональный токен доступа
 */
export const accessTokenControllerDeleteItem = (
    id: string,
 ) => {
      
      
      return customInstance<CountResponseOutput>(
      {url: `/api/v2/auth/access_tokens/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getAccessTokenControllerDeleteItemMutationOptions = <TError = CountResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerDeleteItem>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerDeleteItem>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['accessTokenControllerDeleteItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accessTokenControllerDeleteItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  accessTokenControllerDeleteItem(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AccessTokenControllerDeleteItemMutationResult = NonNullable<Awaited<ReturnType<typeof accessTokenControllerDeleteItem>>>
    
    export type AccessTokenControllerDeleteItemMutationError = CountResponseOutput

    /**
 * @summary Отозвать персональный токен доступа
 */
export const useAccessTokenControllerDeleteItem = <TError = CountResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerDeleteItem>>, TError,{id: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof accessTokenControllerDeleteItem>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAccessTokenControllerDeleteItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить текущий тариф
 */
export const quotaControllerGetQuota = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<UserQuotaResponseOutput>(
      {url: `/api/v2/user/quota`, method: 'GET', signal
    },
      );
    }
  

export const getQuotaControllerGetQuotaQueryKey = () => {
    return [`/api/v2/user/quota`] as const;
    }

    
export const getQuotaControllerGetQuotaQueryOptions = <TData = Awaited<ReturnType<typeof quotaControllerGetQuota>>, TError = UserQuotaResponseOutput>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof quotaControllerGetQuota>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuotaControllerGetQuotaQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof quotaControllerGetQuota>>> = ({ signal }) => quotaControllerGetQuota(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof quotaControllerGetQuota>>, TError, TData> & { queryKey: QueryKey }
}

export type QuotaControllerGetQuotaQueryResult = NonNullable<Awaited<ReturnType<typeof quotaControllerGetQuota>>>
export type QuotaControllerGetQuotaQueryError = UserQuotaResponseOutput


/**
 * @summary Получить текущий тариф
 */

export function useQuotaControllerGetQuota<TData = Awaited<ReturnType<typeof quotaControllerGetQuota>>, TError = UserQuotaResponseOutput>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof quotaControllerGetQuota>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getQuotaControllerGetQuotaQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить лимиты для рабочего пространства
 */
export const quotaControllerGetQuotaWorkspace = (
    workspaceId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/workspaces/${workspaceId}/quota`, method: 'GET', signal
    },
      );
    }
  

export const getQuotaControllerGetQuotaWorkspaceQueryKey = (workspaceId: string,) => {
    return [`/api/v2/workspaces/${workspaceId}/quota`] as const;
    }

    
export const getQuotaControllerGetQuotaWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof quotaControllerGetQuotaWorkspace>>, TError = unknown>(workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof quotaControllerGetQuotaWorkspace>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuotaControllerGetQuotaWorkspaceQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof quotaControllerGetQuotaWorkspace>>> = ({ signal }) => quotaControllerGetQuotaWorkspace(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof quotaControllerGetQuotaWorkspace>>, TError, TData> & { queryKey: QueryKey }
}

export type QuotaControllerGetQuotaWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof quotaControllerGetQuotaWorkspace>>>
export type QuotaControllerGetQuotaWorkspaceQueryError = unknown


/**
 * @summary Получить лимиты для рабочего пространства
 */

export function useQuotaControllerGetQuotaWorkspace<TData = Awaited<ReturnType<typeof quotaControllerGetQuotaWorkspace>>, TError = unknown>(
 workspaceId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof quotaControllerGetQuotaWorkspace>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getQuotaControllerGetQuotaWorkspaceQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Опубликовать гостевой документ
 */
export const publishDocControllerPostPublishGuestDoc = (
    workspaceId: string,
    docId: string,
    publishGuestDocBody: PublishGuestDocBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/workspaces/${workspaceId}/guest_docs/${docId}/publish`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: publishGuestDocBody, signal
    },
      );
    }
  


export const getPublishDocControllerPostPublishGuestDocMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishDocControllerPostPublishGuestDoc>>, TError,{workspaceId: string;docId: string;data: PublishGuestDocBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof publishDocControllerPostPublishGuestDoc>>, TError,{workspaceId: string;docId: string;data: PublishGuestDocBody}, TContext> => {
    
const mutationKey = ['publishDocControllerPostPublishGuestDoc'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishDocControllerPostPublishGuestDoc>>, {workspaceId: string;docId: string;data: PublishGuestDocBody}> = (props) => {
          const {workspaceId,docId,data} = props ?? {};

          return  publishDocControllerPostPublishGuestDoc(workspaceId,docId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublishDocControllerPostPublishGuestDocMutationResult = NonNullable<Awaited<ReturnType<typeof publishDocControllerPostPublishGuestDoc>>>
    export type PublishDocControllerPostPublishGuestDocMutationBody = PublishGuestDocBody
    export type PublishDocControllerPostPublishGuestDocMutationError = SuccessResponseOutput

    /**
 * @summary Опубликовать гостевой документ
 */
export const usePublishDocControllerPostPublishGuestDoc = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishDocControllerPostPublishGuestDoc>>, TError,{workspaceId: string;docId: string;data: PublishGuestDocBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof publishDocControllerPostPublishGuestDoc>>,
        TError,
        {workspaceId: string;docId: string;data: PublishGuestDocBody},
        TContext
      > => {

      const mutationOptions = getPublishDocControllerPostPublishGuestDocMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Отозвать публикацию гостевого документа
 */
export const publishDocControllerPostRevokePublicGuestDoc = (
    workspaceId: string,
    docId: string,
    revokeGuestDocBody: RevokeGuestDocBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/workspaces/${workspaceId}/guest_docs/${docId}/revoke`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revokeGuestDocBody, signal
    },
      );
    }
  


export const getPublishDocControllerPostRevokePublicGuestDocMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishDocControllerPostRevokePublicGuestDoc>>, TError,{workspaceId: string;docId: string;data: RevokeGuestDocBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof publishDocControllerPostRevokePublicGuestDoc>>, TError,{workspaceId: string;docId: string;data: RevokeGuestDocBody}, TContext> => {
    
const mutationKey = ['publishDocControllerPostRevokePublicGuestDoc'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishDocControllerPostRevokePublicGuestDoc>>, {workspaceId: string;docId: string;data: RevokeGuestDocBody}> = (props) => {
          const {workspaceId,docId,data} = props ?? {};

          return  publishDocControllerPostRevokePublicGuestDoc(workspaceId,docId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublishDocControllerPostRevokePublicGuestDocMutationResult = NonNullable<Awaited<ReturnType<typeof publishDocControllerPostRevokePublicGuestDoc>>>
    export type PublishDocControllerPostRevokePublicGuestDocMutationBody = RevokeGuestDocBody
    export type PublishDocControllerPostRevokePublicGuestDocMutationError = SuccessResponseOutput

    /**
 * @summary Отозвать публикацию гостевого документа
 */
export const usePublishDocControllerPostRevokePublicGuestDoc = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishDocControllerPostRevokePublicGuestDoc>>, TError,{workspaceId: string;docId: string;data: RevokeGuestDocBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof publishDocControllerPostRevokePublicGuestDoc>>,
        TError,
        {workspaceId: string;docId: string;data: RevokeGuestDocBody},
        TContext
      > => {

      const mutationOptions = getPublishDocControllerPostRevokePublicGuestDocMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить связанных с документом пользователей
 */
export const publishDocControllerPostGuests = (
    workspaceId: string,
    docId: string,
    params?: PublishDocControllerPostGuestsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GuestUserArrayResponseOutput>(
      {url: `/api/v2/workspaces/${workspaceId}/guest_docs/${docId}/guests`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getPublishDocControllerPostGuestsQueryKey = (workspaceId: string,
    docId: string,
    params?: PublishDocControllerPostGuestsParams,) => {
    return [`/api/v2/workspaces/${workspaceId}/guest_docs/${docId}/guests`, ...(params ? [params]: [])] as const;
    }

    
export const getPublishDocControllerPostGuestsQueryOptions = <TData = Awaited<ReturnType<typeof publishDocControllerPostGuests>>, TError = GuestUserArrayResponseOutput>(workspaceId: string,
    docId: string,
    params?: PublishDocControllerPostGuestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof publishDocControllerPostGuests>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublishDocControllerPostGuestsQueryKey(workspaceId,docId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof publishDocControllerPostGuests>>> = ({ signal }) => publishDocControllerPostGuests(workspaceId,docId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && docId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publishDocControllerPostGuests>>, TError, TData> & { queryKey: QueryKey }
}

export type PublishDocControllerPostGuestsQueryResult = NonNullable<Awaited<ReturnType<typeof publishDocControllerPostGuests>>>
export type PublishDocControllerPostGuestsQueryError = GuestUserArrayResponseOutput


/**
 * @summary Получить связанных с документом пользователей
 */

export function usePublishDocControllerPostGuests<TData = Awaited<ReturnType<typeof publishDocControllerPostGuests>>, TError = GuestUserArrayResponseOutput>(
 workspaceId: string,
    docId: string,
    params?: PublishDocControllerPostGuestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof publishDocControllerPostGuests>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPublishDocControllerPostGuestsQueryOptions(workspaceId,docId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Создать документ на основе файла
 */
export const docManagerControllerPostCreate = (
    workspaceId: string,
    docManagerControllerPostCreateBody: DocManagerControllerPostCreateBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(docManagerControllerPostCreateBody.title !== undefined) {
 formData.append('title', docManagerControllerPostCreateBody.title)
 }
formData.append('file', docManagerControllerPostCreateBody.file)

      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/workspaces/${workspaceId}/docs`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getDocManagerControllerPostCreateMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostCreate>>, TError,{workspaceId: string;data: DocManagerControllerPostCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostCreate>>, TError,{workspaceId: string;data: DocManagerControllerPostCreateBody}, TContext> => {
    
const mutationKey = ['docManagerControllerPostCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof docManagerControllerPostCreate>>, {workspaceId: string;data: DocManagerControllerPostCreateBody}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  docManagerControllerPostCreate(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocManagerControllerPostCreateMutationResult = NonNullable<Awaited<ReturnType<typeof docManagerControllerPostCreate>>>
    export type DocManagerControllerPostCreateMutationBody = DocManagerControllerPostCreateBody
    export type DocManagerControllerPostCreateMutationError = SuccessResponseOutput

    /**
 * @summary Создать документ на основе файла
 */
export const useDocManagerControllerPostCreate = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostCreate>>, TError,{workspaceId: string;data: DocManagerControllerPostCreateBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof docManagerControllerPostCreate>>,
        TError,
        {workspaceId: string;data: DocManagerControllerPostCreateBody},
        TContext
      > => {

      const mutationOptions = getDocManagerControllerPostCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Добавить содержимое файла в существующий документ
 */
export const docManagerControllerPostAdd = (
    workspaceId: string,
    docId: string,
    docManagerControllerPostAddBody: DocManagerControllerPostAddBody,
 ) => {
      
      const formData = new FormData();
if(docManagerControllerPostAddBody.mode !== undefined) {
 formData.append('mode', docManagerControllerPostAddBody.mode)
 }
formData.append('file', docManagerControllerPostAddBody.file)

      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/workspaces/${workspaceId}/docs/${docId}`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  


export const getDocManagerControllerPostAddMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostAdd>>, TError,{workspaceId: string;docId: string;data: DocManagerControllerPostAddBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostAdd>>, TError,{workspaceId: string;docId: string;data: DocManagerControllerPostAddBody}, TContext> => {
    
const mutationKey = ['docManagerControllerPostAdd'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof docManagerControllerPostAdd>>, {workspaceId: string;docId: string;data: DocManagerControllerPostAddBody}> = (props) => {
          const {workspaceId,docId,data} = props ?? {};

          return  docManagerControllerPostAdd(workspaceId,docId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocManagerControllerPostAddMutationResult = NonNullable<Awaited<ReturnType<typeof docManagerControllerPostAdd>>>
    export type DocManagerControllerPostAddMutationBody = DocManagerControllerPostAddBody
    export type DocManagerControllerPostAddMutationError = SuccessResponseOutput

    /**
 * @summary Добавить содержимое файла в существующий документ
 */
export const useDocManagerControllerPostAdd = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostAdd>>, TError,{workspaceId: string;docId: string;data: DocManagerControllerPostAddBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof docManagerControllerPostAdd>>,
        TError,
        {workspaceId: string;docId: string;data: DocManagerControllerPostAddBody},
        TContext
      > => {

      const mutationOptions = getDocManagerControllerPostAddMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Безвозвратное удаление документа
 */
export const docManagerControllerPostDelete = (
    workspaceId: string,
    docId: string,
 ) => {
      
      
      return customInstance<CountResponseOutput>(
      {url: `/api/v2/workspaces/${workspaceId}/docs/${docId}`, method: 'DELETE'
    },
      );
    }
  


export const getDocManagerControllerPostDeleteMutationOptions = <TError = CountResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostDelete>>, TError,{workspaceId: string;docId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostDelete>>, TError,{workspaceId: string;docId: string}, TContext> => {
    
const mutationKey = ['docManagerControllerPostDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof docManagerControllerPostDelete>>, {workspaceId: string;docId: string}> = (props) => {
          const {workspaceId,docId} = props ?? {};

          return  docManagerControllerPostDelete(workspaceId,docId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocManagerControllerPostDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof docManagerControllerPostDelete>>>
    
    export type DocManagerControllerPostDeleteMutationError = CountResponseOutput

    /**
 * @summary Безвозвратное удаление документа
 */
export const useDocManagerControllerPostDelete = <TError = CountResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostDelete>>, TError,{workspaceId: string;docId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof docManagerControllerPostDelete>>,
        TError,
        {workspaceId: string;docId: string},
        TContext
      > => {

      const mutationOptions = getDocManagerControllerPostDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Удалить содержимое документа
 */
export const docManagerControllerPostClear = (
    workspaceId: string,
    docId: string,
 ) => {
      
      
      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/workspaces/${workspaceId}/docs/${docId}/content`, method: 'DELETE'
    },
      );
    }
  


export const getDocManagerControllerPostClearMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostClear>>, TError,{workspaceId: string;docId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostClear>>, TError,{workspaceId: string;docId: string}, TContext> => {
    
const mutationKey = ['docManagerControllerPostClear'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof docManagerControllerPostClear>>, {workspaceId: string;docId: string}> = (props) => {
          const {workspaceId,docId} = props ?? {};

          return  docManagerControllerPostClear(workspaceId,docId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocManagerControllerPostClearMutationResult = NonNullable<Awaited<ReturnType<typeof docManagerControllerPostClear>>>
    
    export type DocManagerControllerPostClearMutationError = SuccessResponseOutput

    /**
 * @summary Удалить содержимое документа
 */
export const useDocManagerControllerPostClear = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docManagerControllerPostClear>>, TError,{workspaceId: string;docId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof docManagerControllerPostClear>>,
        TError,
        {workspaceId: string;docId: string},
        TContext
      > => {

      const mutationOptions = getDocManagerControllerPostClearMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить содержимое документа в виде файла
 */
export const docManagerControllerGetFileContent = (
    workspaceId: string,
    docId: string,
    params: DocManagerControllerGetFileContentParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v2/workspaces/${workspaceId}/docs/${docId}/export-content`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      );
    }
  

export const getDocManagerControllerGetFileContentQueryKey = (workspaceId: string,
    docId: string,
    params: DocManagerControllerGetFileContentParams,) => {
    return [`/api/v2/workspaces/${workspaceId}/docs/${docId}/export-content`, ...(params ? [params]: [])] as const;
    }

    
export const getDocManagerControllerGetFileContentQueryOptions = <TData = Awaited<ReturnType<typeof docManagerControllerGetFileContent>>, TError = unknown>(workspaceId: string,
    docId: string,
    params: DocManagerControllerGetFileContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof docManagerControllerGetFileContent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocManagerControllerGetFileContentQueryKey(workspaceId,docId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docManagerControllerGetFileContent>>> = ({ signal }) => docManagerControllerGetFileContent(workspaceId,docId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && docId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof docManagerControllerGetFileContent>>, TError, TData> & { queryKey: QueryKey }
}

export type DocManagerControllerGetFileContentQueryResult = NonNullable<Awaited<ReturnType<typeof docManagerControllerGetFileContent>>>
export type DocManagerControllerGetFileContentQueryError = unknown


/**
 * @summary Получить содержимое документа в виде файла
 */

export function useDocManagerControllerGetFileContent<TData = Awaited<ReturnType<typeof docManagerControllerGetFileContent>>, TError = unknown>(
 workspaceId: string,
    docId: string,
    params: DocManagerControllerGetFileContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof docManagerControllerGetFileContent>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDocManagerControllerGetFileContentQueryOptions(workspaceId,docId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить мета-данные документа
 */
export const docManagerControllerGetDocMeta = (
    workspaceId: string,
    docId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DocMetaResponseOutput>(
      {url: `/api/v2/workspaces/${workspaceId}/docs/${docId}/meta`, method: 'GET', signal
    },
      );
    }
  

export const getDocManagerControllerGetDocMetaQueryKey = (workspaceId: string,
    docId: string,) => {
    return [`/api/v2/workspaces/${workspaceId}/docs/${docId}/meta`] as const;
    }

    
export const getDocManagerControllerGetDocMetaQueryOptions = <TData = Awaited<ReturnType<typeof docManagerControllerGetDocMeta>>, TError = DocMetaResponseOutput>(workspaceId: string,
    docId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof docManagerControllerGetDocMeta>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocManagerControllerGetDocMetaQueryKey(workspaceId,docId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof docManagerControllerGetDocMeta>>> = ({ signal }) => docManagerControllerGetDocMeta(workspaceId,docId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && docId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof docManagerControllerGetDocMeta>>, TError, TData> & { queryKey: QueryKey }
}

export type DocManagerControllerGetDocMetaQueryResult = NonNullable<Awaited<ReturnType<typeof docManagerControllerGetDocMeta>>>
export type DocManagerControllerGetDocMetaQueryError = DocMetaResponseOutput


/**
 * @summary Получить мета-данные документа
 */

export function useDocManagerControllerGetDocMeta<TData = Awaited<ReturnType<typeof docManagerControllerGetDocMeta>>, TError = DocMetaResponseOutput>(
 workspaceId: string,
    docId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof docManagerControllerGetDocMeta>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDocManagerControllerGetDocMetaQueryOptions(workspaceId,docId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Конвертировать документ в выбранный формат
 */
export const docConverterControllerPostConvert = (
    docConverterControllerPostConvertBody: DocConverterControllerPostConvertBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/services/converter/doc`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: docConverterControllerPostConvertBody, signal
    },
      );
    }
  


export const getDocConverterControllerPostConvertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docConverterControllerPostConvert>>, TError,{data: DocConverterControllerPostConvertBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof docConverterControllerPostConvert>>, TError,{data: DocConverterControllerPostConvertBody}, TContext> => {
    
const mutationKey = ['docConverterControllerPostConvert'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof docConverterControllerPostConvert>>, {data: DocConverterControllerPostConvertBody}> = (props) => {
          const {data} = props ?? {};

          return  docConverterControllerPostConvert(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocConverterControllerPostConvertMutationResult = NonNullable<Awaited<ReturnType<typeof docConverterControllerPostConvert>>>
    export type DocConverterControllerPostConvertMutationBody = DocConverterControllerPostConvertBody
    export type DocConverterControllerPostConvertMutationError = unknown

    /**
 * @summary Конвертировать документ в выбранный формат
 */
export const useDocConverterControllerPostConvert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof docConverterControllerPostConvert>>, TError,{data: DocConverterControllerPostConvertBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof docConverterControllerPostConvert>>,
        TError,
        {data: DocConverterControllerPostConvertBody},
        TContext
      > => {

      const mutationOptions = getDocConverterControllerPostConvertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Конвертировать файл в другой формат
 */
export const fileConverterControllerPostConvert = (
    fileConverterControllerPostConvertBody: FileConverterControllerPostConvertBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append('type', fileConverterControllerPostConvertBody.type)
formData.append('file', fileConverterControllerPostConvertBody.file)

      return customInstance<void>(
      {url: `/api/v2/services/converter/file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getFileConverterControllerPostConvertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileConverterControllerPostConvert>>, TError,{data: FileConverterControllerPostConvertBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof fileConverterControllerPostConvert>>, TError,{data: FileConverterControllerPostConvertBody}, TContext> => {
    
const mutationKey = ['fileConverterControllerPostConvert'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileConverterControllerPostConvert>>, {data: FileConverterControllerPostConvertBody}> = (props) => {
          const {data} = props ?? {};

          return  fileConverterControllerPostConvert(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FileConverterControllerPostConvertMutationResult = NonNullable<Awaited<ReturnType<typeof fileConverterControllerPostConvert>>>
    export type FileConverterControllerPostConvertMutationBody = FileConverterControllerPostConvertBody
    export type FileConverterControllerPostConvertMutationError = unknown

    /**
 * @summary Конвертировать файл в другой формат
 */
export const useFileConverterControllerPostConvert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileConverterControllerPostConvert>>, TError,{data: FileConverterControllerPostConvertBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof fileConverterControllerPostConvert>>,
        TError,
        {data: FileConverterControllerPostConvertBody},
        TContext
      > => {

      const mutationOptions = getFileConverterControllerPostConvertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Конвертировать все файлы из выбранной папки в другой формат
 */
export const folderConverterControllerPostConvert = (
    folderConverterControllerPostConvertBody: FolderConverterControllerPostConvertBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/services/converter/folder`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: folderConverterControllerPostConvertBody, signal
    },
      );
    }
  


export const getFolderConverterControllerPostConvertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof folderConverterControllerPostConvert>>, TError,{data: FolderConverterControllerPostConvertBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof folderConverterControllerPostConvert>>, TError,{data: FolderConverterControllerPostConvertBody}, TContext> => {
    
const mutationKey = ['folderConverterControllerPostConvert'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof folderConverterControllerPostConvert>>, {data: FolderConverterControllerPostConvertBody}> = (props) => {
          const {data} = props ?? {};

          return  folderConverterControllerPostConvert(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FolderConverterControllerPostConvertMutationResult = NonNullable<Awaited<ReturnType<typeof folderConverterControllerPostConvert>>>
    export type FolderConverterControllerPostConvertMutationBody = FolderConverterControllerPostConvertBody
    export type FolderConverterControllerPostConvertMutationError = unknown

    /**
 * @summary Конвертировать все файлы из выбранной папки в другой формат
 */
export const useFolderConverterControllerPostConvert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof folderConverterControllerPostConvert>>, TError,{data: FolderConverterControllerPostConvertBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof folderConverterControllerPostConvert>>,
        TError,
        {data: FolderConverterControllerPostConvertBody},
        TContext
      > => {

      const mutationOptions = getFolderConverterControllerPostConvertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Для подключения перейти по url ссылке
 * @summary Подключится к Miro
 */
export const authControllerPostLogin = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/services/miro/auth/login`, method: 'GET', signal
    },
      );
    }
  

export const getAuthControllerPostLoginQueryKey = () => {
    return [`/api/v2/services/miro/auth/login`] as const;
    }

    
export const getAuthControllerPostLoginQueryOptions = <TData = Awaited<ReturnType<typeof authControllerPostLogin>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerPostLogin>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerPostLoginQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerPostLogin>>> = ({ signal }) => authControllerPostLogin(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerPostLogin>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthControllerPostLoginQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerPostLogin>>>
export type AuthControllerPostLoginQueryError = unknown


/**
 * @summary Подключится к Miro
 */

export function useAuthControllerPostLogin<TData = Awaited<ReturnType<typeof authControllerPostLogin>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerPostLogin>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuthControllerPostLoginQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Состояние подключения к Miro
 */
export const authControllerGetAuth = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AuthStateResponseOutput>(
      {url: `/api/v2/services/miro/auth`, method: 'GET', signal
    },
      );
    }
  

export const getAuthControllerGetAuthQueryKey = () => {
    return [`/api/v2/services/miro/auth`] as const;
    }

    
export const getAuthControllerGetAuthQueryOptions = <TData = Awaited<ReturnType<typeof authControllerGetAuth>>, TError = AuthStateResponseOutput>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerGetAuth>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerGetAuthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetAuth>>> = ({ signal }) => authControllerGetAuth(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerGetAuth>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthControllerGetAuthQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerGetAuth>>>
export type AuthControllerGetAuthQueryError = AuthStateResponseOutput


/**
 * @summary Состояние подключения к Miro
 */

export function useAuthControllerGetAuth<TData = Awaited<ReturnType<typeof authControllerGetAuth>>, TError = AuthStateResponseOutput>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authControllerGetAuth>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuthControllerGetAuthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Отключится от Miro
 */
export const authControllerPostLogout = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/services/miro/auth/logout`, method: 'POST', signal
    },
      );
    }
  


export const getAuthControllerPostLogoutMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerPostLogout>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerPostLogout>>, TError,void, TContext> => {
    
const mutationKey = ['authControllerPostLogout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerPostLogout>>, void> = () => {
          

          return  authControllerPostLogout()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerPostLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerPostLogout>>>
    
    export type AuthControllerPostLogoutMutationError = SuccessResponseOutput

    /**
 * @summary Отключится от Miro
 */
export const useAuthControllerPostLogout = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerPostLogout>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerPostLogout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAuthControllerPostLogoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить список всех досок из Miro
 */
export const miroControllerGetBoards = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MiroBoardArrayResponseOutput>(
      {url: `/api/v2/services/miro/boards`, method: 'GET', signal
    },
      );
    }
  

export const getMiroControllerGetBoardsQueryKey = () => {
    return [`/api/v2/services/miro/boards`] as const;
    }

    
export const getMiroControllerGetBoardsQueryOptions = <TData = Awaited<ReturnType<typeof miroControllerGetBoards>>, TError = MiroBoardArrayResponseOutput>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof miroControllerGetBoards>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMiroControllerGetBoardsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof miroControllerGetBoards>>> = ({ signal }) => miroControllerGetBoards(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof miroControllerGetBoards>>, TError, TData> & { queryKey: QueryKey }
}

export type MiroControllerGetBoardsQueryResult = NonNullable<Awaited<ReturnType<typeof miroControllerGetBoards>>>
export type MiroControllerGetBoardsQueryError = MiroBoardArrayResponseOutput


/**
 * @summary Получить список всех досок из Miro
 */

export function useMiroControllerGetBoards<TData = Awaited<ReturnType<typeof miroControllerGetBoards>>, TError = MiroBoardArrayResponseOutput>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof miroControllerGetBoards>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMiroControllerGetBoardsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Импорт доски из Miro
 */
export const miroControllerGetSnapshot = (
    boardId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/services/miro/boards/${boardId}/snapshot`, method: 'GET', signal
    },
      );
    }
  

export const getMiroControllerGetSnapshotQueryKey = (boardId: string,) => {
    return [`/api/v2/services/miro/boards/${boardId}/snapshot`] as const;
    }

    
export const getMiroControllerGetSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof miroControllerGetSnapshot>>, TError = unknown>(boardId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof miroControllerGetSnapshot>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMiroControllerGetSnapshotQueryKey(boardId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof miroControllerGetSnapshot>>> = ({ signal }) => miroControllerGetSnapshot(boardId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(boardId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof miroControllerGetSnapshot>>, TError, TData> & { queryKey: QueryKey }
}

export type MiroControllerGetSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof miroControllerGetSnapshot>>>
export type MiroControllerGetSnapshotQueryError = unknown


/**
 * @summary Импорт доски из Miro
 */

export function useMiroControllerGetSnapshot<TData = Awaited<ReturnType<typeof miroControllerGetSnapshot>>, TError = unknown>(
 boardId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof miroControllerGetSnapshot>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMiroControllerGetSnapshotQueryOptions(boardId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Схема доски из Miro
 */
export const miroControllerGetNative = (
    boardId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/services/miro/boards/${boardId}/native`, method: 'GET', signal
    },
      );
    }
  

export const getMiroControllerGetNativeQueryKey = (boardId: string,) => {
    return [`/api/v2/services/miro/boards/${boardId}/native`] as const;
    }

    
export const getMiroControllerGetNativeQueryOptions = <TData = Awaited<ReturnType<typeof miroControllerGetNative>>, TError = unknown>(boardId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof miroControllerGetNative>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMiroControllerGetNativeQueryKey(boardId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof miroControllerGetNative>>> = ({ signal }) => miroControllerGetNative(boardId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(boardId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof miroControllerGetNative>>, TError, TData> & { queryKey: QueryKey }
}

export type MiroControllerGetNativeQueryResult = NonNullable<Awaited<ReturnType<typeof miroControllerGetNative>>>
export type MiroControllerGetNativeQueryError = unknown


/**
 * @summary Схема доски из Miro
 */

export function useMiroControllerGetNative<TData = Awaited<ReturnType<typeof miroControllerGetNative>>, TError = unknown>(
 boardId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof miroControllerGetNative>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMiroControllerGetNativeQueryOptions(boardId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить текущее подключение к Базе Знаний для рабочего пространства
 */
export const wikiControllerGetWikiStatus = (
    params: WikiControllerGetWikiStatusParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetWikiStatusResponseOutput>(
      {url: `/api/v2/services/wiki`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getWikiControllerGetWikiStatusQueryKey = (params: WikiControllerGetWikiStatusParams,) => {
    return [`/api/v2/services/wiki`, ...(params ? [params]: [])] as const;
    }

    
export const getWikiControllerGetWikiStatusQueryOptions = <TData = Awaited<ReturnType<typeof wikiControllerGetWikiStatus>>, TError = GetWikiStatusResponseOutput>(params: WikiControllerGetWikiStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetWikiStatus>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWikiControllerGetWikiStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof wikiControllerGetWikiStatus>>> = ({ signal }) => wikiControllerGetWikiStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetWikiStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type WikiControllerGetWikiStatusQueryResult = NonNullable<Awaited<ReturnType<typeof wikiControllerGetWikiStatus>>>
export type WikiControllerGetWikiStatusQueryError = GetWikiStatusResponseOutput


/**
 * @summary Получить текущее подключение к Базе Знаний для рабочего пространства
 */

export function useWikiControllerGetWikiStatus<TData = Awaited<ReturnType<typeof wikiControllerGetWikiStatus>>, TError = GetWikiStatusResponseOutput>(
 params: WikiControllerGetWikiStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetWikiStatus>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getWikiControllerGetWikiStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Настроить подключение к Базе Знаний для рабочего пространства
 */
export const wikiControllerPostWorkspaceAsWiki = (
    params: WikiControllerPostWorkspaceAsWikiParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/services/wiki`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getWikiControllerPostWorkspaceAsWikiMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wikiControllerPostWorkspaceAsWiki>>, TError,{params: WikiControllerPostWorkspaceAsWikiParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof wikiControllerPostWorkspaceAsWiki>>, TError,{params: WikiControllerPostWorkspaceAsWikiParams}, TContext> => {
    
const mutationKey = ['wikiControllerPostWorkspaceAsWiki'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof wikiControllerPostWorkspaceAsWiki>>, {params: WikiControllerPostWorkspaceAsWikiParams}> = (props) => {
          const {params} = props ?? {};

          return  wikiControllerPostWorkspaceAsWiki(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WikiControllerPostWorkspaceAsWikiMutationResult = NonNullable<Awaited<ReturnType<typeof wikiControllerPostWorkspaceAsWiki>>>
    
    export type WikiControllerPostWorkspaceAsWikiMutationError = SuccessResponseOutput

    /**
 * @summary Настроить подключение к Базе Знаний для рабочего пространства
 */
export const useWikiControllerPostWorkspaceAsWiki = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wikiControllerPostWorkspaceAsWiki>>, TError,{params: WikiControllerPostWorkspaceAsWikiParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof wikiControllerPostWorkspaceAsWiki>>,
        TError,
        {params: WikiControllerPostWorkspaceAsWikiParams},
        TContext
      > => {

      const mutationOptions = getWikiControllerPostWorkspaceAsWikiMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить список активных документов из Базы Знаний
 */
export const wikiControllerGetWikiDocsByWorkspace = (
    params?: WikiControllerGetWikiDocsByWorkspaceParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetWikiDocByWorkspaceArrayResponseOutput>(
      {url: `/api/v2/services/wiki/docs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getWikiControllerGetWikiDocsByWorkspaceQueryKey = (params?: WikiControllerGetWikiDocsByWorkspaceParams,) => {
    return [`/api/v2/services/wiki/docs`, ...(params ? [params]: [])] as const;
    }

    
export const getWikiControllerGetWikiDocsByWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof wikiControllerGetWikiDocsByWorkspace>>, TError = GetWikiDocByWorkspaceArrayResponseOutput>(params?: WikiControllerGetWikiDocsByWorkspaceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetWikiDocsByWorkspace>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWikiControllerGetWikiDocsByWorkspaceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof wikiControllerGetWikiDocsByWorkspace>>> = ({ signal }) => wikiControllerGetWikiDocsByWorkspace(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetWikiDocsByWorkspace>>, TError, TData> & { queryKey: QueryKey }
}

export type WikiControllerGetWikiDocsByWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof wikiControllerGetWikiDocsByWorkspace>>>
export type WikiControllerGetWikiDocsByWorkspaceQueryError = GetWikiDocByWorkspaceArrayResponseOutput


/**
 * @summary Получить список активных документов из Базы Знаний
 */

export function useWikiControllerGetWikiDocsByWorkspace<TData = Awaited<ReturnType<typeof wikiControllerGetWikiDocsByWorkspace>>, TError = GetWikiDocByWorkspaceArrayResponseOutput>(
 params?: WikiControllerGetWikiDocsByWorkspaceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetWikiDocsByWorkspace>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getWikiControllerGetWikiDocsByWorkspaceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Действие с документами
 */
export const wikiControllerPostActionDocs = (
    postDocsStatusBody: PostDocsStatusBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/services/wiki/action`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postDocsStatusBody, signal
    },
      );
    }
  


export const getWikiControllerPostActionDocsMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wikiControllerPostActionDocs>>, TError,{data: PostDocsStatusBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof wikiControllerPostActionDocs>>, TError,{data: PostDocsStatusBody}, TContext> => {
    
const mutationKey = ['wikiControllerPostActionDocs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof wikiControllerPostActionDocs>>, {data: PostDocsStatusBody}> = (props) => {
          const {data} = props ?? {};

          return  wikiControllerPostActionDocs(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WikiControllerPostActionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof wikiControllerPostActionDocs>>>
    export type WikiControllerPostActionDocsMutationBody = PostDocsStatusBody
    export type WikiControllerPostActionDocsMutationError = SuccessResponseOutput

    /**
 * @summary Действие с документами
 */
export const useWikiControllerPostActionDocs = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wikiControllerPostActionDocs>>, TError,{data: PostDocsStatusBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof wikiControllerPostActionDocs>>,
        TError,
        {data: PostDocsStatusBody},
        TContext
      > => {

      const mutationOptions = getWikiControllerPostActionDocsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить активный документ из Базы Знаний
 */
export const wikiControllerGetWikiDocByWorkspace = (
    docId: string,
    params: WikiControllerGetWikiDocByWorkspaceParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetWikiDocByWorkspaceResponseOutput>(
      {url: `/api/v2/services/wiki/docs/${docId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getWikiControllerGetWikiDocByWorkspaceQueryKey = (docId: string,
    params: WikiControllerGetWikiDocByWorkspaceParams,) => {
    return [`/api/v2/services/wiki/docs/${docId}`, ...(params ? [params]: [])] as const;
    }

    
export const getWikiControllerGetWikiDocByWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof wikiControllerGetWikiDocByWorkspace>>, TError = GetWikiDocByWorkspaceResponseOutput>(docId: string,
    params: WikiControllerGetWikiDocByWorkspaceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetWikiDocByWorkspace>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWikiControllerGetWikiDocByWorkspaceQueryKey(docId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof wikiControllerGetWikiDocByWorkspace>>> = ({ signal }) => wikiControllerGetWikiDocByWorkspace(docId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(docId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetWikiDocByWorkspace>>, TError, TData> & { queryKey: QueryKey }
}

export type WikiControllerGetWikiDocByWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof wikiControllerGetWikiDocByWorkspace>>>
export type WikiControllerGetWikiDocByWorkspaceQueryError = GetWikiDocByWorkspaceResponseOutput


/**
 * @summary Получить активный документ из Базы Знаний
 */

export function useWikiControllerGetWikiDocByWorkspace<TData = Awaited<ReturnType<typeof wikiControllerGetWikiDocByWorkspace>>, TError = GetWikiDocByWorkspaceResponseOutput>(
 docId: string,
    params: WikiControllerGetWikiDocByWorkspaceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetWikiDocByWorkspace>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getWikiControllerGetWikiDocByWorkspaceQueryOptions(docId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Start pipeline
 */
export const wikiControllerGetPipeline = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/services/wiki/pipeline`, method: 'GET', signal
    },
      );
    }
  

export const getWikiControllerGetPipelineQueryKey = () => {
    return [`/api/v2/services/wiki/pipeline`] as const;
    }

    
export const getWikiControllerGetPipelineQueryOptions = <TData = Awaited<ReturnType<typeof wikiControllerGetPipeline>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetPipeline>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWikiControllerGetPipelineQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof wikiControllerGetPipeline>>> = ({ signal }) => wikiControllerGetPipeline(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetPipeline>>, TError, TData> & { queryKey: QueryKey }
}

export type WikiControllerGetPipelineQueryResult = NonNullable<Awaited<ReturnType<typeof wikiControllerGetPipeline>>>
export type WikiControllerGetPipelineQueryError = unknown


/**
 * @summary Start pipeline
 */

export function useWikiControllerGetPipeline<TData = Awaited<ReturnType<typeof wikiControllerGetPipeline>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiControllerGetPipeline>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getWikiControllerGetPipelineQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить содержимое документа в виде файла
 */
export const wikiDocControllerGetFileContent = (
    docId: string,
    params: WikiDocControllerGetFileContentParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v2/services/wiki/docs/${docId}/file`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      );
    }
  

export const getWikiDocControllerGetFileContentQueryKey = (docId: string,
    params: WikiDocControllerGetFileContentParams,) => {
    return [`/api/v2/services/wiki/docs/${docId}/file`, ...(params ? [params]: [])] as const;
    }

    
export const getWikiDocControllerGetFileContentQueryOptions = <TData = Awaited<ReturnType<typeof wikiDocControllerGetFileContent>>, TError = unknown>(docId: string,
    params: WikiDocControllerGetFileContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiDocControllerGetFileContent>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWikiDocControllerGetFileContentQueryKey(docId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof wikiDocControllerGetFileContent>>> = ({ signal }) => wikiDocControllerGetFileContent(docId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(docId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wikiDocControllerGetFileContent>>, TError, TData> & { queryKey: QueryKey }
}

export type WikiDocControllerGetFileContentQueryResult = NonNullable<Awaited<ReturnType<typeof wikiDocControllerGetFileContent>>>
export type WikiDocControllerGetFileContentQueryError = unknown


/**
 * @summary Получить содержимое документа в виде файла
 */

export function useWikiDocControllerGetFileContent<TData = Awaited<ReturnType<typeof wikiDocControllerGetFileContent>>, TError = unknown>(
 docId: string,
    params: WikiDocControllerGetFileContentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiDocControllerGetFileContent>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getWikiDocControllerGetFileContentQueryOptions(docId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить мета-данные документа
 */
export const wikiDocControllerGetDocMeta = (
    docId: string,
    params: WikiDocControllerGetDocMetaParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DocMetaResponseOutput>(
      {url: `/api/v2/services/wiki/docs/${docId}/meta`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getWikiDocControllerGetDocMetaQueryKey = (docId: string,
    params: WikiDocControllerGetDocMetaParams,) => {
    return [`/api/v2/services/wiki/docs/${docId}/meta`, ...(params ? [params]: [])] as const;
    }

    
export const getWikiDocControllerGetDocMetaQueryOptions = <TData = Awaited<ReturnType<typeof wikiDocControllerGetDocMeta>>, TError = DocMetaResponseOutput>(docId: string,
    params: WikiDocControllerGetDocMetaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiDocControllerGetDocMeta>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWikiDocControllerGetDocMetaQueryKey(docId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof wikiDocControllerGetDocMeta>>> = ({ signal }) => wikiDocControllerGetDocMeta(docId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(docId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wikiDocControllerGetDocMeta>>, TError, TData> & { queryKey: QueryKey }
}

export type WikiDocControllerGetDocMetaQueryResult = NonNullable<Awaited<ReturnType<typeof wikiDocControllerGetDocMeta>>>
export type WikiDocControllerGetDocMetaQueryError = DocMetaResponseOutput


/**
 * @summary Получить мета-данные документа
 */

export function useWikiDocControllerGetDocMeta<TData = Awaited<ReturnType<typeof wikiDocControllerGetDocMeta>>, TError = DocMetaResponseOutput>(
 docId: string,
    params: WikiDocControllerGetDocMetaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof wikiDocControllerGetDocMeta>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getWikiDocControllerGetDocMetaQueryOptions(docId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Отправить ответ пользователя
 */
export const surveyControllerPostResponse = (
    postResponseBody: PostResponseBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SuccessResponseOutput>(
      {url: `/api/v2/services/survey/response`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postResponseBody, signal
    },
      );
    }
  


export const getSurveyControllerPostResponseMutationOptions = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveyControllerPostResponse>>, TError,{data: PostResponseBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof surveyControllerPostResponse>>, TError,{data: PostResponseBody}, TContext> => {
    
const mutationKey = ['surveyControllerPostResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof surveyControllerPostResponse>>, {data: PostResponseBody}> = (props) => {
          const {data} = props ?? {};

          return  surveyControllerPostResponse(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SurveyControllerPostResponseMutationResult = NonNullable<Awaited<ReturnType<typeof surveyControllerPostResponse>>>
    export type SurveyControllerPostResponseMutationBody = PostResponseBody
    export type SurveyControllerPostResponseMutationError = SuccessResponseOutput

    /**
 * @summary Отправить ответ пользователя
 */
export const useSurveyControllerPostResponse = <TError = SuccessResponseOutput,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof surveyControllerPostResponse>>, TError,{data: PostResponseBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof surveyControllerPostResponse>>,
        TError,
        {data: PostResponseBody},
        TContext
      > => {

      const mutationOptions = getSurveyControllerPostResponseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Получить опрос
 */
export const surveyControllerGetSurvey = (
    params: SurveyControllerGetSurveyParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SurveySchemaResponseOutput>(
      {url: `/api/v2/services/survey/surveys`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getSurveyControllerGetSurveyQueryKey = (params: SurveyControllerGetSurveyParams,) => {
    return [`/api/v2/services/survey/surveys`, ...(params ? [params]: [])] as const;
    }

    
export const getSurveyControllerGetSurveyQueryOptions = <TData = Awaited<ReturnType<typeof surveyControllerGetSurvey>>, TError = SurveySchemaResponseOutput>(params: SurveyControllerGetSurveyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof surveyControllerGetSurvey>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSurveyControllerGetSurveyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveyControllerGetSurvey>>> = ({ signal }) => surveyControllerGetSurvey(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof surveyControllerGetSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type SurveyControllerGetSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof surveyControllerGetSurvey>>>
export type SurveyControllerGetSurveyQueryError = SurveySchemaResponseOutput


/**
 * @summary Получить опрос
 */

export function useSurveyControllerGetSurvey<TData = Awaited<ReturnType<typeof surveyControllerGetSurvey>>, TError = SurveySchemaResponseOutput>(
 params: SurveyControllerGetSurveyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof surveyControllerGetSurvey>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSurveyControllerGetSurveyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить опрос из formbricks
 */
export const surveyControllerGetFbSurvey = (
    params: SurveyControllerGetFbSurveyParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<FbSurveySchemaResponseOutput>(
      {url: `/api/v2/services/survey/fb-surveys`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getSurveyControllerGetFbSurveyQueryKey = (params: SurveyControllerGetFbSurveyParams,) => {
    return [`/api/v2/services/survey/fb-surveys`, ...(params ? [params]: [])] as const;
    }

    
export const getSurveyControllerGetFbSurveyQueryOptions = <TData = Awaited<ReturnType<typeof surveyControllerGetFbSurvey>>, TError = FbSurveySchemaResponseOutput>(params: SurveyControllerGetFbSurveyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof surveyControllerGetFbSurvey>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSurveyControllerGetFbSurveyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveyControllerGetFbSurvey>>> = ({ signal }) => surveyControllerGetFbSurvey(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof surveyControllerGetFbSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type SurveyControllerGetFbSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof surveyControllerGetFbSurvey>>>
export type SurveyControllerGetFbSurveyQueryError = FbSurveySchemaResponseOutput


/**
 * @summary Получить опрос из formbricks
 */

export function useSurveyControllerGetFbSurvey<TData = Awaited<ReturnType<typeof surveyControllerGetFbSurvey>>, TError = FbSurveySchemaResponseOutput>(
 params: SurveyControllerGetFbSurveyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof surveyControllerGetFbSurvey>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSurveyControllerGetFbSurveyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить контакт (Admin)
 */
export const unisenderAdminControllerGetContact = (
    params: UnisenderAdminControllerGetContactParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/services/marketing/contact`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getUnisenderAdminControllerGetContactQueryKey = (params: UnisenderAdminControllerGetContactParams,) => {
    return [`/api/v2/services/marketing/contact`, ...(params ? [params]: [])] as const;
    }

    
export const getUnisenderAdminControllerGetContactQueryOptions = <TData = Awaited<ReturnType<typeof unisenderAdminControllerGetContact>>, TError = unknown>(params: UnisenderAdminControllerGetContactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof unisenderAdminControllerGetContact>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUnisenderAdminControllerGetContactQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof unisenderAdminControllerGetContact>>> = ({ signal }) => unisenderAdminControllerGetContact(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof unisenderAdminControllerGetContact>>, TError, TData> & { queryKey: QueryKey }
}

export type UnisenderAdminControllerGetContactQueryResult = NonNullable<Awaited<ReturnType<typeof unisenderAdminControllerGetContact>>>
export type UnisenderAdminControllerGetContactQueryError = unknown


/**
 * @summary Получить контакт (Admin)
 */

export function useUnisenderAdminControllerGetContact<TData = Awaited<ReturnType<typeof unisenderAdminControllerGetContact>>, TError = unknown>(
 params: UnisenderAdminControllerGetContactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof unisenderAdminControllerGetContact>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUnisenderAdminControllerGetContactQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Получить все доступные списки (Admin)
 */
export const unisenderAdminControllerGetLists = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/services/marketing/lists`, method: 'GET', signal
    },
      );
    }
  

export const getUnisenderAdminControllerGetListsQueryKey = () => {
    return [`/api/v2/services/marketing/lists`] as const;
    }

    
export const getUnisenderAdminControllerGetListsQueryOptions = <TData = Awaited<ReturnType<typeof unisenderAdminControllerGetLists>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof unisenderAdminControllerGetLists>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUnisenderAdminControllerGetListsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof unisenderAdminControllerGetLists>>> = ({ signal }) => unisenderAdminControllerGetLists(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof unisenderAdminControllerGetLists>>, TError, TData> & { queryKey: QueryKey }
}

export type UnisenderAdminControllerGetListsQueryResult = NonNullable<Awaited<ReturnType<typeof unisenderAdminControllerGetLists>>>
export type UnisenderAdminControllerGetListsQueryError = unknown


/**
 * @summary Получить все доступные списки (Admin)
 */

export function useUnisenderAdminControllerGetLists<TData = Awaited<ReturnType<typeof unisenderAdminControllerGetLists>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof unisenderAdminControllerGetLists>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUnisenderAdminControllerGetListsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Обновить дополнительные поля контакта (Admin)
 */
export const unisenderAdminControllerPostSubscribe = (
    params: UnisenderAdminControllerPostSubscribeParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v2/services/marketing/subscribe`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getUnisenderAdminControllerPostSubscribeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unisenderAdminControllerPostSubscribe>>, TError,{params: UnisenderAdminControllerPostSubscribeParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unisenderAdminControllerPostSubscribe>>, TError,{params: UnisenderAdminControllerPostSubscribeParams}, TContext> => {
    
const mutationKey = ['unisenderAdminControllerPostSubscribe'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unisenderAdminControllerPostSubscribe>>, {params: UnisenderAdminControllerPostSubscribeParams}> = (props) => {
          const {params} = props ?? {};

          return  unisenderAdminControllerPostSubscribe(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnisenderAdminControllerPostSubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof unisenderAdminControllerPostSubscribe>>>
    
    export type UnisenderAdminControllerPostSubscribeMutationError = unknown

    /**
 * @summary Обновить дополнительные поля контакта (Admin)
 */
export const useUnisenderAdminControllerPostSubscribe = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unisenderAdminControllerPostSubscribe>>, TError,{params: UnisenderAdminControllerPostSubscribeParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof unisenderAdminControllerPostSubscribe>>,
        TError,
        {params: UnisenderAdminControllerPostSubscribeParams},
        TContext
      > => {

      const mutationOptions = getUnisenderAdminControllerPostSubscribeMutationOptions(options);

      return useMutation(mutationOptions);
    }
